/* eslint-disable @typescript-eslint/no-explicit-any */
import { BASE_API, CONTENT_TYPE_KEYS_ARRAY } from '../utils/constants'
import { getAccessToken } from '../utils/getAlefuser'
import { getSelectedOrganization } from '../utils/selectedOrganization'

export type getCentralisedLogsResponse = {
  totalRows: number
  auditLogs: AuditLogObject[]
  request: {
    sortDirection: 'Desc'
    eventActions: string[]
  } & getCentralisedLogsParams
} & Pick<getCentralisedLogsParams, 'entityType'>

export type getCentralisedLogsParams = {
  entityType: CONTENT_TYPE_KEYS_ARRAY
  searchText: string
  dateRangeFilter?: string
  eventTypes?: string
  statuses: string
  users: { id: number; uuid: string }[]
} & PageOptions
const formatDateForPayload = (stringDate: string) => {
  if (!stringDate) {
    return null
  }
  const dateArr = stringDate.split(',')
  return {
    fromDate: dateArr[0] || null,
    toDate: dateArr[1] || null
  }
}
const getCentralisedLogs = async (params: getCentralisedLogsParams): Promise<getCentralisedLogsResponse> => {
  try {
    const URI = `${BASE_API}/audit/centralisedLogs`
    const organisation = getSelectedOrganization()

    const selectedEventFilters = params.eventTypes ? params.eventTypes.split(',') : []
    const isAllSelected = params.entityType[0] === 'ALL'

    const req = await fetch(URI, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json',
        'X-Tenantid': organisation
      },
      body: JSON.stringify({
        ...params,
        entityType: params.entityType[0],
        dateRangeFilter: formatDateForPayload(params.dateRangeFilter),
        eventTypes: isAllSelected ? [] : selectedEventFilters,
        eventActions: isAllSelected ? selectedEventFilters : [],
        statuses: params.statuses ? params.statuses.split(',') : [],
        users: params.users,
        sortDirection: 'Desc'
      })
    })
    if (req.status !== 200) {
      throw new Error('request Error')
    }
    const data: getCentralisedLogsResponse = await req.json()
    return data
  } catch (e) {
    console.error(e)
    return {
      totalRows: 0,
      auditLogs: [],
      request: {
        sortDirection: 'Desc',
        ...params,
        eventActions: [],
        statuses: ''
      },
      entityType: params.entityType
    }
  }
}

export default getCentralisedLogs
